import Vue from 'vue'
import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
	id: 'G-ELLPBS41HH'
});